import { Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "../services/transalationService";

@Pipe({
  name: 'translate',
  pure: false,
  //A pure pipe is only re-transforming the value, if the value actually changes. That makes a pure pipes really fast and efficient.
    //At the other hand there are the impure pipes.Impure pipes re- transform their value at every change detection cycle of the component.

})
export class TranslatePipe implements PipeTransform {
  constructor(private translationService: TranslationService) {}

  transform(value: any, args?: any): any {
    return this.translationService.translate(value)
  }
}
